import React, { Component } from "react";
import LayoutWrapper from "../LayoutWrapper";

export class ConfigPage extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.state = {
      basic_config_fields: [
        {
          name: "package_name",
          label: "Name",
          type: "text",
          required: true,
        },
        {
          name: "thumbnail_file",
          label: "Thumbnail Image* (Max of 2 MB)",
          type: "file",
          fileType: "package",
          uploadType: "public",
          fileReturnType: "url",
          accept: "image/*",
          required: true,
          checkFileSize: true,
          maxsize: "2", //in mb
        },
        {
          name: "recommended_class",
          label: "Recommended Class",
          type: "select",
          onChange: (...args) => this.handleRecommendedClass(...args),
          multi: true,
          required: true,
        },
        {
          name: "category",
          label: "Category",
          type: "select",
          onChange: (...args) => this.handleCategory(...args),
          multi: true,
          required: true,
        },
        {
          name: "package_description",
          label: "Package Desciption",
          type: "textarea",
          colMdspan: "8",
          required: true,
        },
      ],
      media_configuration: {
        media_images: [],
        media_videos: [""],
      },
      e_comm_configuration: [{}],
      session_config_fields: [
        {
          name: "session_id",
          label: "Session Name",
          type: "select",
          multi: true,
          required: true,
        },
      ],
      selectedClasses: "",
      selectedCategories: "",
      bsqc_url: "",
      bsqc_code: "",
      loader: true,
    };
  }

  get has_edit() {
    return !!this.props.urlparams.package_id;
  }

  get has_view() {
    return !!this.props.urlparams.readonly;
  }

  addField(e, fieldname) {
    let { media_configuration } = this.state;
    media_configuration[fieldname] = [...media_configuration[fieldname], ""];
    this.setState({
      media_configuration,
    });
  }
  deleteField(e, index, fieldname) {
    e.preventDefault();
    const removeLocal = () => {
      let { media_configuration } = this.state;
      media_configuration[fieldname] = media_configuration[fieldname].filter(
        (v, i) => i != index
      );
      this.setState({
        media_configuration,
      });
    };
    removeLocal();
  }

  addEcommConfig(e) {
    let { e_comm_configuration } = this.state;
    e_comm_configuration = [...e_comm_configuration, ""];
    this.setState({
      e_comm_configuration,
    });
  }
  deleteEcommConfig(e, index) {
    e.preventDefault();
    const removeLocal = () => {
      let { e_comm_configuration } = this.state;
      e_comm_configuration = e_comm_configuration.filter((v, i) => i != index);
      this.setState({
        e_comm_configuration,
      });
    };
    removeLocal();
  }
  // ----------------------------------------------------------------
  componentDidMount() {
    const _this = this;

    // Prevent programmatic focus within react-dropdown-select from scrolling the page
    this.originalFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function (options) {
      if (this.closest && this.closest(".react-dropdown-select")) {
        return _this.originalFocus.call(this, {
          ...(typeof options === "object" && options !== null ? options : {}),
          preventScroll: true,
        });
      }
      return _this.originalFocus.call(this, options);
    };

    // Prevent react-dropdown-select Item scrollIntoView from scrolling the page/window
    this.originalScrollIntoView = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function (options) {
      if (this.closest && this.closest(".react-dropdown-select")) {
        const dropdown = this.closest(".react-dropdown-select-dropdown");
        if (dropdown) {
          const itemTop = this.offsetTop;
          const itemBottom = itemTop + this.offsetHeight;
          const dropTop = dropdown.scrollTop;
          const dropBottom = dropTop + dropdown.clientHeight;
          if (itemTop < dropTop) {
            dropdown.scrollTop = itemTop;
          } else if (itemBottom > dropBottom) {
            dropdown.scrollTop = itemBottom - dropdown.clientHeight;
          }
        }
        return;
      }
      return _this.originalScrollIntoView?.call(this, options);
    };

    // Close any open dropdowns when clicking outside (on mousedown, before blur/focus fight can occur)
    this.handleGlobalMouseDown = (e) => {
      const target = e.target;
      if (!target) return;
      const clickedSelect = target.closest && target.closest(".react-dropdown-select");
      const clickedDropdown = target.closest && target.closest(".react-dropdown-select-dropdown");

      document.querySelectorAll("[name^='appinput-']").forEach((el) => {
        if (el.contains(target) || (clickedSelect && el.contains(clickedSelect))) {
          return;
        }
        if (
          clickedDropdown &&
          el.querySelector &&
          el.querySelector(".react-dropdown-select-dropdown") === clickedDropdown
        ) {
          return;
        }
        const select = el.vnode?.refs?.select || el.vnode?.refs?.select2;
        if (select && select.state?.dropdown) {
          select.dropDown("close");
        }
      });
    };
    document.addEventListener("mousedown", this.handleGlobalMouseDown, true);

    // Close any open dropdown when user scrolls the main page/window
    this.handleGlobalScroll = (e) => {
      if (e && e.target && e.target.closest && e.target.closest(".react-dropdown-select")) {
        return;
      }
      document.querySelectorAll("[name^='appinput-']").forEach((el) => {
        const select = el.vnode?.refs?.select || el.vnode?.refs?.select2;
        if (select && select.state?.dropdown) {
          select.dropDown("close");
        }
      });
    };
    window.addEventListener("scroll", this.handleGlobalScroll, true);

    this.setState({ loader: true });

    if (this.props.urlparams.package_id) {
      Promise.all([
        this.props.api.apiGetPackageById({
          package_id: this.props.urlparams.package_id,
        }),
        this.props.api.apiGetClasses(),
      ])
        .then(async ([packageRes, classesRes]) => {
          let data = packageRes?.data;
          let classesData = (classesRes?.data || []).sort(
            (a, b) => a.curriculum_level - b.curriculum_level
          );
          let classlistOpts =
            classesData?.options("curriculum_id", "curriculum_grade") || [];
          let sessionOpts = [];

          // Parse recommended_class
          let recClassIds = [];
          if (Array.isArray(data?.recommended_class)) {
            recClassIds = data.recommended_class
              .map((c) =>
                typeof c === "object" && c !== null
                  ? c.curriculum_id || c._id || c.id || c.key
                  : c
              )
              .filter(Boolean);
          } else if (typeof data?.recommended_class === "string") {
            recClassIds = data.recommended_class
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean);
          }
          let recClass = recClassIds.join(",");

          // Parse category
          let categoryIds = [];
          let rawCategories =
            data?.category || data?.categories || data?.sub_modules || [];
          if (Array.isArray(rawCategories)) {
            categoryIds = rawCategories
              .map((c) =>
                typeof c === "object" && c !== null
                  ? c.sub_module_id || c._id || c.id || c.key
                  : c
              )
              .filter(Boolean);
          } else if (typeof rawCategories === "string") {
            categoryIds = rawCategories
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean);
          }

          // Parse session_id
          let sessionIds = [];
          let rawSessions =
            data?.session_id || data?.sessionDetails || data?.sessions || [];
          if (Array.isArray(rawSessions)) {
            sessionIds = rawSessions
              .map((s) =>
                typeof s === "object" && s !== null
                  ? s.session_id || s._id || s.id || s.key
                  : s
              )
              .filter(Boolean);
          } else if (typeof rawSessions === "string") {
            sessionIds = rawSessions
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean);
          }

          // Fetch categories for recommended classes in the package
          let categoryOpts = [];
          if (recClass) {
            try {
              let categoryRes = await this.props.api.apiGetSubModules({
                curriculum_id: recClass,
              });
              categoryOpts =
                categoryRes?.data?.[0]?.records?.map((v) => ({
                  ...v,
                  key: v?.sub_module_id,
                  label: `${v?.sub_module_name} (${v?.curriculum_name})`,
                })) || [];
            } catch (err) {
              console.error("Error fetching categories:", err);
            }
          }

          // Fetch sessions according to category (sub_module_id comma-separated)
          let catIdsStr = categoryIds.join(",");
          let sessionPayload = { audience_type: "B2C" };
          if (catIdsStr) {
            sessionPayload.sub_module_id = catIdsStr;
          }
          if (recClass) {
            sessionPayload.curriculum_id = recClass;
          }
          if (catIdsStr || recClass) {
            try {
              let sessionsRes = await this.props.api.apiGetSessionsList(
                sessionPayload
              );
              sessionOpts =
                sessionsRes?.data?.[0]?.records?.options(
                  "session_id",
                  "session_name"
                ) || [];
            } catch (err) {
              console.error("Error fetching sessions:", err);
            }
          }

          let updatedBasicFields = this.state.basic_config_fields.map(
            (field) => {
              let defVal = data?.[field.name];
              let opts = field.options;
              if (field.name === "recommended_class") {
                defVal = recClassIds;
                opts = classlistOpts;
              } else if (field.name === "category") {
                defVal = categoryIds;
                opts = categoryOpts;
              }
              return {
                ...field,
                defaultValue: defVal,
                options: opts,
                disabled: this.has_view,
              };
            }
          );

          let updatedSessionConfigFields = this.state.session_config_fields.map(
            (field) => {
              let defVal = data?.[field.name];
              let opts = field.options;
              if (field.name === "session_id") {
                defVal = sessionIds;
                opts = sessionOpts;
              }
              return {
                ...field,
                defaultValue: defVal,
                options: opts,
                disabled: this.has_view,
              };
            }
          );

          this.setState({
            selectedClasses: recClass,
            selectedCategories: catIdsStr,
            basic_config_fields: updatedBasicFields,
            session_config_fields: updatedSessionConfigFields,
            media_configuration: {
              media_images:
                data?.media_configuration?.media_images &&
                data?.media_configuration?.media_images.length > 0
                  ? [...data?.media_configuration?.media_images]
                  : [],
              media_videos:
                data?.media_configuration?.media_videos &&
                data?.media_configuration?.media_videos?.length !== 0
                  ? [...data?.media_configuration?.media_videos]
                  : [""],
            },
            e_comm_configuration:
              data?.e_comm_configuration && data?.e_comm_configuration.length > 0
                ? [...data?.e_comm_configuration]
                : [{}],
            bsqc_url: data?.bsqc_url || "",
            bsqc_code: data?.bsqc_code || "",
            loader: false,
          });
        })
        .catch((err) => {
          console.error("Error loading package data:", err);
          this.setState({ loader: false });
        });
    } else {
      // ADD MODE
      this.props.api
        .apiGetClasses()
        .then((classesRes) => {
          let classesData = (classesRes?.data || []).sort(
            (a, b) => a.curriculum_level - b.curriculum_level
          );
          let classlistOpts =
            classesData?.options("curriculum_id", "curriculum_grade") || [];

          let updatedBasicFields = this.state.basic_config_fields.map(
            (field) => {
              if (field.name === "recommended_class") {
                return {
                  ...field,
                  options: classlistOpts,
                };
              }
              return { ...field };
            }
          );

          let updatedSessionConfigFields = this.state.session_config_fields.map(
            (field) => {
              if (field.name === "session_id") {
                return {
                  ...field,
                  options: [],
                };
              }
              return { ...field };
            }
          );

          this.setState({
            selectedClasses: "",
            selectedCategories: "",
            basic_config_fields: updatedBasicFields,
            session_config_fields: updatedSessionConfigFields,
            loader: false,
          });
        })
        .catch((err) => {
          console.error("Error loading initial data:", err);
          this.setState({ loader: false });
        });
    }
  }

  clearCategory() {
    let categoryInput = document.querySelector(
      "[name='appinput-category'].form-group, [name='appinput-category']"
    );
    let selectRef =
      categoryInput?.vnode?.refs?.select ||
      categoryInput?.vnode?.refs?.select2;
    if (selectRef && typeof selectRef.clearAll === "function") {
      selectRef.clearAll();
    }
    if (categoryInput?.vnode?.setOption) {
      categoryInput.vnode.setOption([]);
    }

    let inputEle = categoryInput?.querySelector(
      ".react-dropdown-select>div+input"
    );
    if (inputEle) {
      inputEle.value = "";
      inputEle.dataset.invalue = "";
      if (inputEle.parentElement) {
        inputEle.parentElement.dataset.value = "";
      }
    }
  }

  clearSession() {
    let sessionInput = document.querySelector(
      "[name='appinput-session_id'].form-group, [name='appinput-session_id']"
    );
    let selectRef =
      sessionInput?.vnode?.refs?.select ||
      sessionInput?.vnode?.refs?.select2;
    if (selectRef && typeof selectRef.clearAll === "function") {
      selectRef.clearAll();
    }
    if (sessionInput?.vnode?.setOption) {
      sessionInput.vnode.setOption([]);
    }

    let inputEle = sessionInput?.querySelector(
      ".react-dropdown-select>div+input"
    );
    if (inputEle) {
      inputEle.value = "";
      inputEle.dataset.invalue = "";
      if (inputEle.parentElement) {
        inputEle.parentElement.dataset.value = "";
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleGlobalMouseDown, true);
    window.removeEventListener("scroll", this.handleGlobalScroll, true);
    if (this.originalFocus) {
      HTMLElement.prototype.focus = this.originalFocus;
    }
    if (this.originalScrollIntoView) {
      Element.prototype.scrollIntoView = this.originalScrollIntoView;
    }
  }

  getCategory(param) {
    this.props.api.apiGetSubModules(param).then((res) => {
      let categoryOpts =
        res?.data?.[0]?.records?.map((v) => {
          return {
            ...v,
            key: v?.sub_module_id,
            label: `${v?.sub_module_name} (${v?.curriculum_name})`,
          };
        }) || [];
      let updatedFields = this.state.basic_config_fields.map((field) => {
        if (field.name === "category") {
          return {
            ...field,
            defaultValue: [],
            options: categoryOpts,
          };
        } else {
          return { ...field };
        }
      });
      this.setState({
        basic_config_fields: updatedFields,
      });
    });
  }

  getSessions(curriculum_id = null, sub_module_id = null) {
    let payload = {
      audience_type: "B2C",
    };

    if (curriculum_id) {
      payload.curriculum_id = curriculum_id;
    }

    if (sub_module_id) {
      payload.sub_module_id = sub_module_id;
    }

    this.props.api.apiGetSessionsList(payload).then((res) => {
      let sessionOpts =
        res?.data?.[0]?.records?.options(
          "session_id",
          "session_name"
        ) || [];

      let updatedFields = this.state.session_config_fields.map((field) => {
        if (field.name === "session_id") {
          return {
            ...field,
            defaultValue: [],
            options: sessionOpts,
          };
        } else {
          return { ...field };
        }
      });
      this.setState({
        session_config_fields: updatedFields,
      });
    });
  }

  handleCategory(record) {
    if (this.state.loader) return;
    this.clearSession();
    let selectedCategories = record
      ?.map((v) =>
        typeof v === "object" && v !== null
          ? v?.sub_module_id || v?.key || v?.id || v?._id
          : v
      )
      .filter(Boolean)
      .join(",");

    this.setState({ selectedCategories });

    if (selectedCategories) {
      this.getSessions(this.state.selectedClasses || null, selectedCategories);
    } else {
      let updatedFields = this.state.session_config_fields.map((field) => {
        if (field.name === "session_id") {
          return {
            ...field,
            defaultValue: [],
            options: [],
          };
        } else {
          return { ...field };
        }
      });
      this.setState({
        session_config_fields: updatedFields,
      });
    }
  }

  handleRecommendedClass(record) {
    if (this.state.loader) return;
    this.clearCategory();
    this.clearSession();
    let selectedClasses = record
      ?.map((v) => v?.curriculum_id || v?.key)
      .filter(Boolean)
      .join(",");

    this.setState({ selectedClasses, selectedCategories: "" });

    if (selectedClasses) {
      this.getCategory({ curriculum_id: selectedClasses });
    } else {
      let updatedFields = this.state.basic_config_fields.map((field) => {
        if (field.name === "category") {
          return {
            ...field,
            defaultValue: [],
            options: [],
          };
        } else {
          return { ...field };
        }
      });
      this.setState({
        basic_config_fields: updatedFields,
      });
    }

    let updatedSessionFields = this.state.session_config_fields.map((field) => {
      if (field.name === "session_id") {
        return {
          ...field,
          defaultValue: [],
          options: [],
        };
      } else {
        return { ...field };
      }
    });
    this.setState({
      session_config_fields: updatedSessionFields,
    });
  }

  submitForm() {
    let data = this.refs.form.form.current.getData();
    let parsedPayload = parseInput(data) || {};
    let payload = {
      ...parsedPayload,
    };
    console.log({ parsedPayload, payload });

    let attachmentIds = [];
    let thumbnailFileObj = {};
    let mediaImageContainers = document.querySelectorAll(
      "[name='appinput-media_configuration.media_images'] [data-attachment-id]"
    );
    let thumbnailAttachmentId = document.querySelector(
      "input[name='thumbnail_file']"
    ).value;

    if (mediaImageContainers)
      mediaImageContainers.forEach((item) =>
        attachmentIds.push({
          attachment_id: item?.dataset.attachmentId,
          url: item?.dataset.thumbnailUrl,
        })
      );

    if (thumbnailAttachmentId) {
      thumbnailFileObj.url = payload.thumbnail_file;
      thumbnailFileObj.attachment_id = thumbnailAttachmentId;
    }
    payload.media_configuration.media_images = attachmentIds;
    payload.thumbnail_file = thumbnailFileObj;
    if (payload.bsqc_url?.length > 0) {
      payload.bsqc_url = data?.bsqc_url;
    } else {
      delete payload.bsqc_url;
    }
    console.log({ payload });

    if (this.has_edit) {
      let editDataPayload = { ...payload };
      this.props.api
        .apiUpdatePackage(Object.except(editDataPayload, "bsqc_code"), {
          package_id: this.props.urlparams.package_id,
        })
        .then((res) => {
          success("Package Updated Successfully");
          this.props.navigate("/businesstoconsumerconfig");
        });
    } else {
      this.props.api.apiAddPackage(payload).then((res) => {
        success("Package Added Successfully");
        this.props.navigate("/businesstoconsumerconfig");
      });
    }
  }
  getTitle() {
    return `B2C Package Configuration`;
  }
  getBreadCums() {
    let packagename = this.props.urlparams.package_name;
    if (this.props.urlparams.package_id && this.props.urlparams.readonly) {
      return `B2C Package Configuration / ${packagename} View Detail`;
    } else if (this.props.urlparams.package_id) {
      return `B2C Package Configuration / ${packagename} Edit Detail`;
    } else {
      return `B2C Package Configuration / Add Package`;
    }
  }
  render() {
    let { props, has_edit, has_view } = this;
    let {
      basic_config_fields,
      media_configuration,
      e_comm_configuration,
      session_config_fields,
      bsqc_url,
      bsqc_code,
    } = this.state;
    return (
      <>
        <LayoutWrapper
          title={this.getTitle()}
          back={this.getBreadCums()}
          backlink="/businesstoconsumerconfig"
        >
          {this.state.loader ? (
            <div className="loader-container">
              <div className="spinner"></div>
            </div>
          ) : (
            <AppForm ref="form">
              {/* BASIC CONFIG */}
              <div className="config_card row mb-4">
                <div className="col-12">
                  <h2 className="title">Basic Configuration</h2>
                </div>
                {basic_config_fields?.map((field, i) => (
                  <div
                    className={`col-sm-6 col-md-${field?.colMdspan || "4"}`}
                    key={field.name || i}
                  >
                    <AppInput
                      key={`${field.name}_${field.options?.length || 0}`}
                      {...field}
                    ></AppInput>
                  </div>
                ))}
              </div>

              {/* MEDIA CONFIG */}
              <div className="config_card row mb-4">
                <div className="col-12">
                  <h2 className="title">Media Configuration</h2>
                </div>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="row">
                      <div className="col-10">
                        <AppInput
                          name={`media_configuration.media_images`}
                          label={"Images (Max of 5 MB)"}
                          type="fileCropModal"
                          required={true}
                          accept={"image/*"}
                          fileType="package"
                          uploadType="public"
                          fileReturnType="url"
                          checkFileSize={true}
                          maxsize="5" //in mb
                          defaultValue={media_configuration.media_images}
                          {...(media_configuration?.media_images
                            ? {
                                defaultValue: media_configuration?.media_images,
                              }
                            : {})}
                          disabled={has_view}
                        ></AppInput>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="row">
                      {media_configuration?.media_videos?.map((field, i) => (
                        <>
                          <div className="col-10" key={i}>
                            <AppInput
                              name={`media_configuration.media_videos.${i}`}
                              label={"Videos (Max of 5 MB)"}
                              type="text"
                              defaultValue={field}
                              disabled={has_view}
                            ></AppInput>
                          </div>
                          <div className="col-2 d-flex">
                            {i != 0 && !props.urlparams.readonly && (
                              <button
                                onClick={(e) =>
                                  this.deleteField(e, i, "media_videos")
                                }
                                className="btn bg-red-500 m-auto mb-2 text-white"
                              >
                                <i className="fa fa-trash-o text-error m-0" />
                              </button>
                            )}
                          </div>
                        </>
                      ))}
                      <div>
                        {!props.urlparams.readonly && (
                          <button
                            className={Object.className({
                              "btn bg-transparent flex gap-2 text-primary": true,
                              "d-none":
                                media_configuration?.media_videos?.length === 5,
                            })}
                            type="button"
                            onClick={(e) => this.addField(e, "media_videos")}
                          >
                            <i className="fa fa-plus m-auto" />
                            <span className="font-bold">Add More</span>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* E-COMM CONFIG */}
              <div className="config_card row mb-4">
                <div className="col-12">
                  <h2 className="title">E-Comm Configuration</h2>
                </div>
                <div className="row">
                  {e_comm_configuration?.map((field, i) => (
                    <>
                      <div className="col-12 col-md-3" key={i}>
                        <AppInput
                          name={`e_comm_configuration.${i}.platform_name`}
                          label="E-commerce Platform Name"
                          type="select"
                          options={_enum.ECOMMERCE_PLATFORM_NAMES}
                          required={true}
                          defaultValue={field?.platform_name || ""}
                          disabled={has_view}
                        ></AppInput>
                      </div>
                      <div className="col-12 col-md-3" key={i}>
                        <AppInput
                          name={`e_comm_configuration.${i}.product_url`}
                          label="Product URL"
                          type="text"
                          defaultValue={field?.product_url || ""}
                          disabled={has_view}
                        ></AppInput>
                      </div>
                      <div className="col-12 col-md-2" key={i}>
                        <AppInput
                          name={`e_comm_configuration.${i}.price`}
                          label="Price"
                          type="number"
                          defaultValue={field?.price || ""}
                          disabled={has_view}
                        ></AppInput>
                      </div>
                      <div
                        className="col-12 col-md-2 d-flex delete_icon_column"
                        key={i}
                      >
                        <AppInput
                          name={`e_comm_configuration.${i}.discount`}
                          label="Discount"
                          type="number"
                          defaultValue={field?.discount || ""}
                          disabled={has_view}
                        ></AppInput>
                        {i != 0 && !props.urlparams.readonly && (
                          <button
                            onClick={(e) => this.deleteEcommConfig(e, i)}
                            className="btn bg-red-500 m-auto mx-0 mb-2 text-white"
                          >
                            <i className="fa fa-trash-o text-error m-0" />
                          </button>
                        )}
                      </div>
                    </>
                  ))}
                  <div>
                    {!props.urlparams.readonly && (
                      <button
                        className="btn bg-transparent flex gap-2 text-primary"
                        type="button"
                        onClick={(e) => this.addEcommConfig(e)}
                      >
                        <i className="fa fa-plus m-auto" />
                        <span className="font-bold">Add More</span>
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* SESSION CONFIG */}
              <div className="config_card row mb-4">
                <div className="col-12">
                  <h2 className="title">Session Configuration</h2>
                </div>
                {session_config_fields?.map((field, i) => (
                  <div
                    className={`col-sm-6 col-md-${field?.colMdspan || "10"}`}
                    key={field.name || i}
                  >
                    <AppInput
                      key={`${field.name}_${field.options?.length || 0}`}
                      {...field}
                    ></AppInput>
                  </div>
                ))}
              </div>

              {/* BSqC CONFIG */}
              <div className="config_card row mb-4">
                <div className="col-12">
                  <h2 className="title">BSqC Configuration</h2>
                </div>
                <div className={`col-sm-6 col-md-8`}>
                  <AppInput
                    name="bsqc_url"
                    type="text"
                    label="URL"
                    requried={true}
                    defaultValue={bsqc_url || ""}
                  ></AppInput>
                </div>
                {bsqc_code && (
                  <div className={`col-sm-6 col-md-4`}>
                    <AppInput
                      name="bsqc_code"
                      type="text"
                      label="Code"
                      requried={true}
                      defaultValue={bsqc_code || ""}
                      readOnly={true}
                    ></AppInput>
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-12 d-flex justify-content-end">
                  <button
                    type="button"
                    onClick={() =>
                      this.props.navigate(`/businesstoconsumerconfig`)
                    }
                    className="btn close-btn col col-md-1 ml-auto rounded-1 text-dark "
                  >
                    Cancel
                  </button>
                  <button
                    className={Object.className({
                      "btn btn-success btn-block": true,
                      "d-none": has_view,
                    })}
                    onClick={() => this.submitForm()}
                  >
                    {has_edit ? "Update" : "Submit"}
                  </button>
                </div>
              </div>
            </AppForm>
          )}
        </LayoutWrapper>
      </>
    );
  }
}

export default connect(ConfigPage);
